import {get, appendPaginationQueryParamsToUrl} from '../utils'

export default host => (clientId, include="", options = {}) =>
  get(appendPaginationQueryParamsToUrl(`${host}/clients/${clientId}/people${include ? `?include=${include}` : ''}`, {
    ...options,
    alreadyHasQueryParams: !!include
  }))
    .then(response => response.json())
